import { render, staticRenderFns } from "./ShopChange.vue?vue&type=template&id=4a4e7e47&scoped=true&"
import script from "./ShopChange.vue?vue&type=script&lang=js&"
export * from "./ShopChange.vue?vue&type=script&lang=js&"
import style0 from "./ShopChange.vue?vue&type=style&index=0&id=4a4e7e47&lang=scss&scoped=true&"
import style1 from "./ShopChange.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a4e7e47",
  null
  
)

export default component.exports